export default (filterGroup, userFilter) => {
  const otherFilters =
    userFilter && userFilter.$and
      ? userFilter.$and.filter(v => !v[filterGroup.toLowerCase()])
      : [];

  return JSON.parse(JSON.stringify({ $and: otherFilters }));
};
